import React, { useState } from "react";
import { PrinterOutlined } from "@ant-design/icons";
import { Modal, Button, Typography, Checkbox, Row, Col, Flex } from "antd";
import axiosInstance from "utilities/axios";

const { Text } = Typography;

const PrintModal = ({ searchParam, filterParams, open, onClose }) => {
  const [includeClinicName, setIncludeClinicName] = useState(false);
  const [includePhone, setIncludePhone] = useState(false);
  const [includeAddress, setIncludeAddress] = useState(false);
  const [includeHp, setIncludeHp] = useState(false);
  const [loading, setLoading] = useState(false);

  const [vendorWarning, setVendorWarning] = useState(false);

  const handlePrint = () => {
    const params = {
      // search: searchParam,
      clinics: filterParams.clinics,
      credentialType: filterParams.credentialTypes,
      region: filterParams.region,
      division: filterParams.division,
      vendor: filterParams.vendor,

      includeClinicName: includeClinicName,
      includePhone: includePhone,
      includeAddress: includeAddress,
      includeHp: includeHp,
    };
    setLoading(true);

    axiosInstance
      .get("/credentials/print", { params, responseType: "blob" }) // Ensure server sends a blob
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        //get file name from response headers
        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[1]
        );

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link); // Clean up
        window.URL.revokeObjectURL(url); // Free up resources
      })
      .catch((error) => {
        console.error("Error printing:", error);
      })
      .finally(() => {
        setLoading(false);
        onClose();
      });
  };

  const handleClinicNameChange = () => {
    setIncludeClinicName(!includeClinicName);
  };

  const handlePhoneChange = () => {
    setIncludePhone(!includePhone);
  };

  const handleAddressChange = () => {
    setIncludeAddress(!includeAddress);
  };

  const handleHpChange = () => {
    setIncludeHp(!includeHp);
  };

  return (
    <Modal
      title="Print Options"
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <Row gutter={8} wrap={true}>
          <Col span={12}>
            <Flex vertical>
              <Checkbox onChange={handleClinicNameChange}>
                Include Clinic Names
              </Checkbox>
            </Flex>
          </Col>
          <Col span={12}>
            <Flex vertical>
              <Checkbox onChange={handlePhoneChange}>
                Include Phone Numbers
              </Checkbox>
            </Flex>
          </Col>
          <Col span={12}>
            <Flex vertical>
              <Checkbox onChange={handleAddressChange}>
                Include Addresses
              </Checkbox>
            </Flex>
          </Col>
          <Col span={12}>
            <Flex vertical>
              <Checkbox onChange={handleHpChange}>Include HPs</Checkbox>
            </Flex>
          </Col>
        </Row>
        <Button
          type="primary"
          size="large"
          className="mt-4"
          icon={<PrinterOutlined />}
          loading={loading}
          onClick={() => {
            if (filterParams.vendor.length === 0) {
              setVendorWarning(true);
            } else {
              handlePrint();
              setVendorWarning(false);
            }
          }}
        >
          Print
        </Button>
        <Text type="danger" hidden={!vendorWarning}>
          Please select at least one vendor
        </Text>
      </div>
    </Modal>
  );
};

export default PrintModal;
